import { InjectionToken } from '@angular/core';

/**
 * Configuration for message logging, provided by the app so the shared
 * MessageLoggingService does not depend on environment or app-specific services.
 */
export interface MessageLoggingConfig {
  /** When true, messages are sent to Sentry. */
  sentryEnabled: boolean;
  /** When set, messages are also sent to Application Insights via this callback. */
  logToAppInsights?: (error: Error) => void;
}

export const MESSAGE_LOGGING_CONFIG = new InjectionToken<MessageLoggingConfig>('MESSAGE_LOGGING_CONFIG');
